module.exports = __webpack_public_path__ + "img/5-itol-search.9d0c2968.png";